import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fixed-deduction-grid',
  templateUrl: './fixed-deduction-grid.component.html',
  styleUrls: ['./fixed-deduction-grid.component.css']
})
export class FixedDeductionGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/emp-salary-details/fixed-deductions/fixed-deduction-grid/fixed-deduction-grid.component.ts